module.exports = __webpack_public_path__ + "img/40.d13fd068.jpg";